// A bookmark export nests <dl> lists: each <dt> is either a link, or a folder
// heading followed by another <dl>. Folders become lists, so a folder's own
// links are grouped under its full path and nested folders become their own
// entries rather than being flattened into the parent.
function processDl(dl, folderPath) {
  const directUrls = [];
  const subFolders = [];

  Array.from(dl.querySelectorAll(':scope > dt')).forEach((dt) => {
    const a = dt.querySelector(':scope > a[href]');
    const h3 = dt.querySelector(':scope > h3');
    const nestedDl = dt.querySelector(':scope > dl');

    if (a) {
      const href = a.getAttribute('href');
      if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
        directUrls.push(href);
      }
    } else if (h3 && nestedDl) {
      const name = h3.textContent.trim();
      const subPath = folderPath ? `${folderPath} › ${name}` : name;
      subFolders.push(...processDl(nestedDl, subPath));
    }
  });

  const result = [];
  if (directUrls.length > 0) {
    result.push({ name: folderPath || 'Bookmarks', urls: directUrls, selectedUrls: directUrls.map(() => true) });
  }
  result.push(...subFolders);
  return result;
}

function isWebUrl(href) {
  return Boolean(href) && (href.startsWith('http://') || href.startsWith('https://'));
}

/** The `http(s)` lines of a pasted block, one URL per line. */
export function parseUrls(text) {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.startsWith('http'));
}

/**
 * Reads an uploaded bookmark file both ways in a single parse: `folders` is the
 * folder tree, and `urls` is every link in the file regardless of nesting.
 *
 * A file with no recognizable folder structure yields an empty `folders`, and
 * the caller falls back to `urls` as a flat paste.
 */
export function readBookmarkFile(htmlText) {
  const doc = new DOMParser().parseFromString(htmlText, 'text/html');
  const topDl = doc.querySelector('dl');

  return {
    folders: topDl ? processDl(topDl, '') : [],
    urls: Array.from(doc.querySelectorAll('a[href]'))
      .map((a) => a.getAttribute('href'))
      .filter(isWebUrl),
  };
}
